export enum WidgetSalePerformanceEnum {
    SALES_REGISTERED = 'SALES_REGISTERED',
    TOTAL_AMMOUNT_SOLD = 'TOTAL_AMMOUNT_SOLD',
    AVERAGE_PACKAGES_PER_SALE = 'AVERAGE_PACKAGES_PER_SALE',
    AVERAGE_DISCOUNT = 'AVERAGE_DISCOUNT',
    SALES_CANCELED = 'SALES_CANCELED',
    RESELL_IN_APPLICATION_ROOM = 'RESELL_IN_APPLICATION_ROOM',
    SALES_REVENUE = 'SALES_REVENUE', // Soma do valor das vendas sem considerar vendas no status PPP.
}
